import { Add } from "@mui/icons-material";
import { Button } from "@mui/material";
import React from "react";

function AddNoteButton(props) {
  return (
    <Button
      startIcon={<Add />}
      style={{
        width: "auto",
        height: "45px",
        marginRight: props.leftMargin === "none" ? 0 : "40px",
        marginLeft: props.leftMargin === "none" ? 0 : "20px",
      }}
      variant="outlined"
      onClick={props.handleOpen}
    >
      {props.title}
    </Button>
  );
}

export default AddNoteButton;
